class ContactStaff {
  constructor({ _id = null, name = '', email = '', role = '', image = '', title = '', bio = '', regions = [] } = {}) {
    this._id = _id;
    this.name = name;
    this.email = email;
    this.role = role;
    this.image = image;
    this.title = title;
    this.bio = bio;
    // regions may be an array of region ids or region objects; keep as-is
    this.regions = Array.isArray(regions) ? regions : [];
  }

  static fromJSON(json = {}) {
    if (!json) return new ContactStaff();

    const regions = Array.isArray(json.regions)
      ? json.regions.map((r) => (r && (r._id || r.id)) ? (r._id || r.id) : r)
      : [];

    return new ContactStaff({
      _id: json._id || json.id || null,
      name: json.name || '',
      email: json.email || '',
      role: json.role || '',
      image: json.image || json.imageURL || '',
      title: json.title || '',
      bio: json.bio || '',
      regions,
    });
  }

  toJSON() {
    return {
      _id: this._id,
      email: this.email,
      name: this.name,
      role: this.role,
      image: this.image,
      title: this.title,
      bio: this.bio,
      // send regions as array of ids
      regions: Array.isArray(this.regions) ? this.regions.map((r) => (r && (r._id || r.id)) ? (r._id || r.id) : r) : [],
    };
  }
}

export default ContactStaff;
